export const oidcOptions = {
  authority: `${process.env.REACT_APP_AUTHORITY}`,
  redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
  postLogoutRedirectUri: `${process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI}`,
};
